import * as Sentry from '@sentry/react';

const SENTRY_DSN =
  'https://391b60a2c6842479fdb3e95c842c2570@o4506597813256192.ingest.us.sentry.io/4509208548343808';

export const initSentry = () => {
  const environment = import.meta.env.VITE_APP_ENV;

  if (!environment || environment?.toLowerCase() === 'local') {
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    sendDefaultPii: true,
    environment,
  });
};

export const reactErrorHandler = Sentry.reactErrorHandler;
